import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length > _vm.itemsPerPage)?_c(VPagination,{attrs:{"length":_vm.paginationLength,"total-visible":11,"circle":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }